import { Heading, Text, Center, Box, Divider } from "@chakra-ui/react";

export default function About() {
 return <div>
  <Text fontSize='3xl' mt={2} color='purple'>
   <Divider />
   <Center style={{ fontWeight: '500' }}>
    ABOUT GANET
   </Center>
  </Text>

  <Box pb={3}>
   <Text>
    Gender Advocacy Network (GANET) started in 2012 by a group of activists who saw the need for women to play  a more proactive role in promoting gender justice in the Niger Delta
   </Text>
  </Box>

  <Box pb={3}>
   <Text>
    GANET has a clear interest in working together with women groups to bring a gender perspective and policy change to National and Regional processes
   </Text>
  </Box>

  <Box pb={3}>
   <Text>
    GANET seeks to achieve gender eqaulity and equity and draw attention to violations of women's rights.
   </Text>
  </Box>


  <Box pb={3}>
   <Text>
    Through its programming, it aims to create space for debates, platform, discussions, dialogue, information sharing and dissemination within the Niger Delta Women's Rights Movement and create public awareness about Women's Human Rights Advocacy.
   </Text>
  </Box>
  <Box pb={3}>
   <Text>
    GANET seeks to address gaps identified in the lack of collective approach to addressing women's human rights issues. There is need for response to critical issues confronting women in the Niger Delta region and GANET seeks to provide that platform that can effectively support the work of the national machinery on women issues.
   </Text>
  </Box>
  <Box pb={3}>
   <Text>
    GANET also works at improving women's access to justice, champoining women's rights protection and engaging men as male champions for women's rights.
   </Text>
  </Box>

  <Box pb={3}>
   <Center>
    <Text color='red' style={{ fontWeight: '500' }}>
     VISION
    </Text>
   </Center>
  </Box>

  <Box pb={3}>
   <Text>
    A just and fair society where women are fully empowered to participate and benefit from decision making processes.
   </Text>
  </Box>

  <Box pb={3}>
   <Center>
    <Text color='purple' style={{ fontWeight: '500' }}>
     MISSION
    </Text>
   </Center>
  </Box>

  <Box pb={3}>
   <Text>
    To build partnerships and collaborations that can effectively champion women's Right and development
   </Text>
  </Box>

  <Box pb={3}>
   <Center>
    <Text color='purple' style={{ fontWeight: '500' }}>
     OBJECTIVES/GOALS
    </Text>
   </Center>
  </Box>

  <Box pb={3}>
   <Text>
    <ol>
     <li>
      To build a stong coalition and network of women's rights groups committed to campaigning for women's rights
     </li>

     <li>
      Provide a forum for imformation sharing, women's learning, networking and exprerience sharing.
     </li>
     <li>
      To strengthen and support CSO presence and participation in the women's rights discourse.
     </li>
     <li>
      Advocate for gender equality in Government laws, policies and programmes.
     </li>
     <li>
      Identify and implement strategies for grassroots mobilixation to help change beliefs and behaviours that perpetuate gender violence.
     </li>
     <li>
      Build synergies for a collective voice on gender equity and women's empowerment.
     </li>
    </ol>
   </Text>

  </Box>

  <Box pb={3}>
   <Text style={{ fontWeight: '500' }}>
    VALUES:
   </Text>
   <ol>
    <li>
     Sisterhood
    </li>
    <li>
     Respect for Human Rights
    </li>
    <li>
     Respect for Diversity
    </li>
   </ol>
  </Box>

  <Box pb={3}>
   <Text style={{ fontWeight: '500' }} color='red'>
    OUR PROGRAM AREAS:
   </Text>
   <ol>
    <li>
     GANET LEGAL ADVOCACY PROGRAMMER (GALAP)
    </li>
    <li>
     Gender Based Violence (Violence free safe space + Help lines)

    </li>
    <li>
     Gender Responsive Budgetting
    </li>
    <li>
     Women's Political Participation
    </li>
    <li>
     Community Empowerment
    </li>
    <li>
     Policy Engagement and Strategic Partnerships.
    </li>
    <li>
     Institutional and Capacity Developement (Research and Training Centre for Women's Leadership)
    </li>
    <li>
     Women's Right Education Program (WREP)
    </li>
   </ol>
  </Box>

  <Box pb={3}>
   <Box>
    <Text style={{ fontWeight: '500' }} color='white' bg='purple' p='3'>
     GOVERNANCE AND STRUCTURE OF GANET
    </Text>

   </Box>
   <ol>
    <li>
     Board of Directors
    </li>
    <li>
     Central Working Committe (CWC) 

    </li>
    <li>
     The National Coordinator
    </li>
    <li>
     Deputy National Coordinator
    </li>
    <li>
     Regional Coordinator
    </li>
    <li>
     The General Assembly
    </li>
    <li>
     Secretariat (Progamme Officer, Assistant, Field Officers)
    </li>
   </ol>
  </Box>

  <Box pb={3}>
   <Box>
    <Text style={{ fontWeight: '500' }} color='black' p='2'>
     MEMBERSHIP:
    </Text>

   </Box>
   <Text>
     GANET has two categories of membership:
    </Text>
   <ol>
    <li>
     Full Membership - Open to women groups and individual women who share our values and goals
    </li>
    <li>
     Associate Membership - Involves men and women (Young/Middle Aged) corporate entities and bodies that share our vision and goals 

    </li>
    <li>
     The National Coordinator
    </li>
    <li>
     Deputy National Coordinator
    </li>
    <li>
     Regional Coordinator
    </li>
    <li>
     The General Assembly
    </li>
    <li>
     Secretariat (Progamme Officer, Assistant, Field Officers)
    </li>
   </ol>
  </Box>

  

 </div>;
}
